import { getImagesTabsFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritImagesTabs/getImagesTabsFunction';
import { GetImagesTabsQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritImagesTabs/getImagesTabsQuery.type';
import { queryOptions } from '@tanstack/react-query';

export const getImagesTabsQueryOptions = (
  params: GetImagesTabsQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['GET_IMAGE_TABS', params],
    queryFn: () => getImagesTabsFunction(params),
    select: (data) => {
      return {
        ...data,
        customer: {
          list: [...data.customer],
          exist: data.customer.find((item) => item.exists),
        },
      };
    },
  });
};
